import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class PartnerApplicationRestService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	uploadFile(file: File, successCallback?, errorCallback?) {
		var formData: any = new FormData();
		formData.append('file', file);

		var httpPromise: any = this.httpClient.post(
			this.config.getRestUrl() + 'publicrest/partner/application/file/upload',
			formData,
			{
				observe: 'response'
			}
		);
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitApplication(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(
			this.config.getRestUrl() + 'publicrest/partner/application',
			data,
			{
				observe: 'response'
			}
		);
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
}
